import { jsx as i, jsxs as I } from "react/jsx-runtime";
import * as c from "react";
import { u as K, c as P } from "./index-D7uzFyzw.js";
import { c as k, P as y, u as E } from "./index-Bud8rdvZ.js";
import { c as N, R as T, I as U } from "./index-CTTPhBZn.js";
import { u as V } from "./index-BsL1G1kw.js";
import { u as j } from "./index-5jQiYUd6.js";
import { u as z } from "./index-BZPx6jYI.js";
import { P as H } from "./index-B6DkbY8I.js";
var w = "Radio", [W, G] = k(w), [X, Y] = W(w), S = c.forwardRef(
  (r, n) => {
    const {
      __scopeRadio: e,
      name: t,
      checked: o = !1,
      required: a,
      disabled: s,
      value: p = "on",
      onCheck: f,
      form: m,
      ...R
    } = r, [l, v] = c.useState(null), d = E(n, (h) => v(h)), u = c.useRef(!1), _ = l ? m || !!l.closest("form") : !0;
    return /* @__PURE__ */ I(X, { scope: e, checked: o, disabled: s, children: [
      /* @__PURE__ */ i(
        y.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": D(o),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: p,
          ...R,
          ref: d,
          onClick: P(r.onClick, (h) => {
            o || f?.(), _ && (u.current = h.isPropagationStopped(), u.current || h.stopPropagation());
          })
        }
      ),
      _ && /* @__PURE__ */ i(
        x,
        {
          control: l,
          bubbles: !u.current,
          name: t,
          value: p,
          checked: o,
          required: a,
          disabled: s,
          form: m,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
S.displayName = w;
var g = "RadioIndicator", A = c.forwardRef(
  (r, n) => {
    const { __scopeRadio: e, forceMount: t, ...o } = r, a = Y(g, e);
    return /* @__PURE__ */ i(H, { present: t || a.checked, children: /* @__PURE__ */ i(
      y.span,
      {
        "data-state": D(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: n
      }
    ) });
  }
);
A.displayName = g;
var $ = "RadioBubbleInput", x = c.forwardRef(
  ({
    __scopeRadio: r,
    control: n,
    checked: e,
    bubbles: t = !0,
    ...o
  }, a) => {
    const s = c.useRef(null), p = E(s, a), f = z(e), m = j(n);
    return c.useEffect(() => {
      const R = s.current;
      if (!R) return;
      const l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(
        l,
        "checked"
      ).set;
      if (f !== e && d) {
        const u = new Event("click", { bubbles: t });
        d.call(R, e), R.dispatchEvent(u);
      }
    }, [f, e, t]), /* @__PURE__ */ i(
      y.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: e,
        ...o,
        tabIndex: -1,
        ref: p,
        style: {
          ...o.style,
          ...m,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
x.displayName = $;
function D(r) {
  return r ? "checked" : "unchecked";
}
var J = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], C = "RadioGroup", [Q, me] = k(C, [
  N,
  G
]), M = N(), F = G(), [Z, ee] = Q(C), O = c.forwardRef(
  (r, n) => {
    const {
      __scopeRadioGroup: e,
      name: t,
      defaultValue: o,
      value: a,
      required: s = !1,
      disabled: p = !1,
      orientation: f,
      dir: m,
      loop: R = !0,
      onValueChange: l,
      ...v
    } = r, d = M(e), u = V(m), [_, h] = K({
      prop: a,
      defaultProp: o ?? null,
      onChange: l,
      caller: C
    });
    return /* @__PURE__ */ i(
      Z,
      {
        scope: e,
        name: t,
        required: s,
        disabled: p,
        value: _,
        onValueChange: h,
        children: /* @__PURE__ */ i(
          T,
          {
            asChild: !0,
            ...d,
            orientation: f,
            dir: u,
            loop: R,
            children: /* @__PURE__ */ i(
              y.div,
              {
                role: "radiogroup",
                "aria-required": s,
                "aria-orientation": f,
                "data-disabled": p ? "" : void 0,
                dir: u,
                ...v,
                ref: n
              }
            )
          }
        )
      }
    );
  }
);
O.displayName = C;
var L = "RadioGroupItem", B = c.forwardRef(
  (r, n) => {
    const { __scopeRadioGroup: e, disabled: t, ...o } = r, a = ee(L, e), s = a.disabled || t, p = M(e), f = F(e), m = c.useRef(null), R = E(n, m), l = a.value === o.value, v = c.useRef(!1);
    return c.useEffect(() => {
      const d = (_) => {
        J.includes(_.key) && (v.current = !0);
      }, u = () => v.current = !1;
      return document.addEventListener("keydown", d), document.addEventListener("keyup", u), () => {
        document.removeEventListener("keydown", d), document.removeEventListener("keyup", u);
      };
    }, []), /* @__PURE__ */ i(
      U,
      {
        asChild: !0,
        ...p,
        focusable: !s,
        active: l,
        children: /* @__PURE__ */ i(
          S,
          {
            disabled: s,
            required: a.required,
            checked: l,
            ...f,
            ...o,
            name: a.name,
            ref: R,
            onCheck: () => a.onValueChange(o.value),
            onKeyDown: P((d) => {
              d.key === "Enter" && d.preventDefault();
            }),
            onFocus: P(o.onFocus, () => {
              v.current && m.current?.click();
            })
          }
        )
      }
    );
  }
);
B.displayName = L;
var oe = "RadioGroupIndicator", q = c.forwardRef(
  (r, n) => {
    const { __scopeRadioGroup: e, ...t } = r, o = F(e);
    return /* @__PURE__ */ i(A, { ...o, ...t, ref: n });
  }
);
q.displayName = oe;
var Re = O, re = B, te = q;
const ae = "_indicator_o29me_51", ne = "_label_o29me_66", b = {
  "radio-item": "_radio-item_o29me_29",
  "radio-button": "_radio-button_o29me_33",
  indicator: ae,
  label: ne
};
function ve({ value: r, id: n, label: e, description: t }) {
  return /* @__PURE__ */ I("div", { className: b["radio-item"], children: [
    /* @__PURE__ */ i(re, { value: r, id: n, className: b["radio-button"], "aria-label": e, children: /* @__PURE__ */ i(te, { className: b.indicator }) }),
    /* @__PURE__ */ I("label", { htmlFor: n, className: b.label, children: [
      e,
      t && /* @__PURE__ */ i("p", { children: t })
    ] })
  ] });
}
export {
  ve as I,
  Re as R
};
